module.exports = __webpack_public_path__ + "img/poster_a01.0efc9f7a.jpg";